var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-container',{attrs:{"notifications":_vm.chartsToDelete,"id-prop":"chartId"},scopedSlots:_vm._u([{key:"default",fn:function({ notification }){return [_c('delete-notification-item',{attrs:{"chart":notification}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }